/**
 * W8a (besluit Frank 22 oktober 2026): de webacties van een agentrun, voor het
 * spoorpaneel. Een agent mag alleen lezen, met de schakelaar op zijn kaart; elke
 * aanroep staat in zijn spoor als `claw_tool`-stap (`services/agent_rounds.py`).
 *
 * PUUR.
 */

/** Dezelfde set als `agent_tools.AGENT_WEB_TOOLS` in de backend. */
export const AGENT_WEB_TOOLS = ["browse_url", "extract_content"];

/** De webstappen van een spoorregel: gereedschap, adres en uitkomst. */
export function webacties(steps) {
  return (steps || [])
    .filter((s) => s && s.type === "claw_tool" && AGENT_WEB_TOOLS.includes(s.tool))
    .map((s) => ({ tool: s.tool, url: s.target || (s.args && s.args.url) || "", outcome: s.outcome || "" }));
}
